import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import SearchActions from '../actions/SearchActions';
import EmptySearchResult from '../components/search/EmptySearchResult';

class EmptySearchResultContainer extends BcReactComponent {
  render() {
    const { query, title, titleKey, activeFilters, chatWidgets, didYouMeanQuerySuggestion, didYouMeanResultCount, hasStaticEmptySearchResults,
            broadened, broadenedSearchType, searchType, showExternalSearchLink, rssURL, customEdit, suppress, orderedSearchTypes, locked, didNotFindOptions, singleBranch } = this.props;

    return (
      <EmptySearchResult
        query={query}
        title={title}
        titleKey={titleKey}
        activeFilters={activeFilters}
        chatWidgets={chatWidgets}
        didYouMeanQuerySuggestion={didYouMeanQuerySuggestion}
        didYouMeanResultCount={didYouMeanResultCount}
        hasStaticEmptySearchResults={hasStaticEmptySearchResults}
        broadened={broadened}
        broadenedSearchType={broadenedSearchType}
        searchType={searchType}
        showExternalSearchLink={showExternalSearchLink}
        customEdit={customEdit}
        suppress={suppress}
        rssURL={rssURL}
        orderedSearchTypes={orderedSearchTypes}
        locked={locked}
        didNotFindOptions={didNotFindOptions}
        singleBranch={singleBranch} />
    );
  }
}

EmptySearchResultContainer.propTypes = {
  query: PropTypes.string,
  title: PropTypes.string,
  titleKey: PropTypes.string,
  locked: PropTypes.bool,
  activeFilters: ImmutablePropTypes.mapOf(PropTypes.object).isRequired,
  chatWidgets: ImmutablePropTypes.mapOf(PropTypes.object),
  orderedSearchTypes: ImmutablePropTypes.list,
  didYouMeanQuerySuggestion: PropTypes.string,
  didYouMeanResultCount: PropTypes.number,
  hasStaticEmptySearchResults: PropTypes.bool.isRequired,
  searchType: PropTypes.string,
  broadened: PropTypes.bool,
  broadenedSearchType: PropTypes.string,
  rssURL: PropTypes.string,
  customEdit: PropTypes.bool,
  suppress: PropTypes.bool,
  didNotFindOptions: ImmutablePropTypes.map,
  singleBranch: PropTypes.bool
};

const mapStateToProps = state => {
  const catalogSearch = state.getIn(['search', 'catalogSearch']);
  const library = currentLibrarySelector(state);

  return {
    broadened: catalogSearch.get('broadened'),
    broadenedSearchType: catalogSearch.get('broadenedSearchType'),
    searchType: catalogSearch.get('searchType'),
    locked: catalogSearch.get('locked'),
    query: catalogSearch.get('query'),
    title: catalogSearch.get('title'),
    activeFilters: catalogSearch.get('activeFilters'),
    chatWidgets: library.get('chatWidgets'),
    didYouMeanQuerySuggestion: catalogSearch.get('didYouMeanQuerySuggestion'),
    didYouMeanResultCount: catalogSearch.get('didYouMeanResultCount'),
    hasStaticEmptySearchResults: !!state.getIn(['localization', 'messages', 'static_empty_search_results_page']),
    showExternalSearchLink: library.get('showExternalSearchLink'),
    suppress: catalogSearch.get('suppress'),
    rssURL: catalogSearch.get('rssURL'),
    customEdit: catalogSearch.get('custom_edit'),
    titleKey: catalogSearch.get('title_key'),
    orderedSearchTypes: library.get('orderedSearchTypes', Immutable.List()),
    didNotFindOptions: library.get('didNotFindOptions'),
    singleBranch: library.get('singleBranch')
  };
};

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EmptySearchResultContainer);



// WEBPACK FOOTER //
// ./app/containers/EmptySearchResultContainer.jsx